export const MIN_WIDTH_GRID_ITEM: number = 120
export const DEFAULT_GRID_COLUMNS: number = 4

export type ColumnsTypes = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 'auto'

export const GUTTER_STATIC = {
  STANDARD: 'standard',
  NONE: 'none',
  SMALL: 'small',
} as const

export const GUTTER_VARIANT = {
  HALF: 0.5,
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
  SIX: 6,
  SEVEN: 7,
  EIGHT: 8,
  STANDARD: GUTTER_STATIC.STANDARD,
  NONE: GUTTER_STATIC.NONE,
} as const

type GutterStaticType = typeof GUTTER_STATIC
type GutterStaticKeys = keyof GutterStaticType
export type GutterStaticTypes = GutterStaticType[GutterStaticKeys]

type GutterVariantType = typeof GUTTER_VARIANT
type GutterVariantKeys = keyof GutterVariantType
export type GutterVariantTypes = GutterVariantType[GutterVariantKeys]

export const CONTENT_ALIGNMENT_VARIANT = {
  SPACE_BETWEEN: 'space-between',
  NONE: 'start',
} as const

type ContentAlignmentVariantType = typeof CONTENT_ALIGNMENT_VARIANT
type ContentVariantKeys = keyof ContentAlignmentVariantType
export type ContentAlignmentTypes = ContentAlignmentVariantType[ContentVariantKeys]
